import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJersey = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 9,
	viewBox: "0 0 10 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1422_3363)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9.6715 2.15227L7.64962 1.16016C7.60381 1.13734 7.55237 1.12525 7.50001 1.125H6.25001C6.16713 1.125 6.08765 1.15463 6.02904 1.20738C5.97044 1.26012 5.93751 1.33166 5.93751 1.40625C5.93751 1.63003 5.83874 1.84464 5.66293 2.00287C5.48711 2.16111 5.24866 2.25 5.00001 2.25C4.75137 2.25 4.51292 2.16111 4.3371 2.00287C4.16129 1.84464 4.06251 1.63003 4.06251 1.40625C4.06251 1.33166 4.02959 1.26012 3.97099 1.20738C3.91238 1.15463 3.8329 1.125 3.75002 1.125H2.50002C2.44753 1.1252 2.39594 1.13729 2.35001 1.16016L0.328531 2.15227C0.184429 2.2208 0.0764078 2.33797 0.0281518 2.47809C-0.0201043 2.6182 -0.0046562 2.76981 0.0711087 2.89969L0.823843 4.19379C0.878575 4.28683 0.960616 4.36458 1.06103 4.41857C1.16145 4.47256 1.2764 4.50072 1.39337 4.5H2.18752V7.3125C2.18752 7.46168 2.25336 7.60476 2.37057 7.71025C2.48778 7.81574 2.64675 7.875 2.81252 7.875H7.18751C7.35327 7.875 7.51225 7.81574 7.62946 7.71025C7.74667 7.60476 7.81251 7.46168 7.81251 7.3125V4.5H8.60705C8.72402 4.50072 8.83897 4.47256 8.93939 4.41857C9.0398 4.36458 9.12184 4.28683 9.17658 4.19379L9.92931 2.89969C10.005 2.76977 10.0204 2.61812 9.97211 2.478C9.92377 2.33789 9.81567 2.22074 9.6715 2.15227ZM1.39337 3.9375C1.3876 3.93775 1.38192 3.93612 1.37736 3.93293L0.628531 2.64586L2.18752 1.88016V3.9375H1.39337ZM8.62267 3.93258C8.62051 3.93433 8.61798 3.93567 8.61522 3.93652C8.61247 3.93736 8.60956 3.9377 8.60666 3.9375H7.81251V1.88016L9.37189 2.64586L8.62267 3.93258Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1422_3363",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 10,
			height: 9,
			fill: "white"
		})
	}) })]
});
export default SvgJersey;
